module.exports = __webpack_public_path__ + "img/prva-iskanje.svg";